import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { logSessionAttribution } from './storefrontEvents';

/** Capture UTM / referrer once per browser session for admin attribution analytics. */
export default function StorefrontAttributionTracker() {
  const location = useLocation();
  const { token } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const utmSource = params.get('utm_source') || '';
    const utmMedium = params.get('utm_medium') || '';
    const utmCampaign = params.get('utm_campaign') || '';
    let referrer = '';
    try {
      referrer = document.referrer || '';
    } catch {
      referrer = '';
    }
    logSessionAttribution({
      utmSource,
      utmMedium,
      utmCampaign,
      referrer,
      landingPath: `${location.pathname}${location.search}`,
      authToken: token || null,
    });
  }, [location.pathname, location.search, token]);

  return null;
}
